module.exports = __webpack_public_path__ + "static/media/build-3.ce962b41.jpg";